import { AlertTriangle } from 'lucide-react';
import { useAuth } from '../lib/auth-context';

/**
 * Closes residual R6: a Lite tenant sees an empty Deceptions page with no
 * explanation, because the control plane gates the deception engine on
 * `tenant.tier !== 'lite'` (packages/control-plane/src/routes/ingest.ts).
 *
 * That failure is otherwise completely silent — detection keeps working, the
 * fleet reports healthy, and the product simply never runs. Say so.
 */
export function LiteTierBanner() {
  const { tenant } = useAuth();

  if (!tenant || tenant.tier !== 'lite') return null;

  return (
    <div
      role="status"
      className="flex items-start gap-3 border-b border-amber-500/30 bg-amber-500/10 px-4 py-2.5"
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-amber-400" aria-hidden="true" />
      <p className="text-[13px] leading-snug text-amber-200">
        <span className="font-semibold">Deceptions are disabled on the Lite plan.</span>{' '}
        Threat detection and telemetry are running normally, but no decoys are served, so
        Deceptions and engagement metrics stay empty. Upgrading to Pro or Enterprise is
        operator-provisioned during beta.
      </p>
    </div>
  );
}
